var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _linearGradient25, _linearGradient26, _linearGradient27, _linearGradient28, _linearGradient29, _linearGradient30, _linearGradient31, _linearGradient32, _linearGradient33, _linearGradient34, _linearGradient35, _linearGradient36, _linearGradient37, _linearGradient38, _linearGradient39, _linearGradient40, _linearGradient41, _linearGradient42, _linearGradient43, _linearGradient44, _linearGradient45, _linearGradient46, _linearGradient47, _linearGradient48, _linearGradient49, _linearGradient50, _linearGradient51, _linearGradient52, _linearGradient53, _linearGradient54, _linearGradient55, _linearGradient56, _linearGradient57, _linearGradient58, _linearGradient59, _linearGradient60, _linearGradient61, _linearGradient62, _linearGradient63, _linearGradient64, _linearGradient65, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPizza(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#faa68e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2061,
    stopColor: "#fba682"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5808,
    stopColor: "#fda861"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa936"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 223.354,
    x2: 250.264,
    xlinkHref: "#lg1",
    y1: 298.877,
    y2: 357.872
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#f12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#dd2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c0272d"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 251.503,
    x2: 228.789,
    xlinkHref: "#lg2",
    y1: 361.785,
    y2: 296.086
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 145.065,
    x2: 264.908,
    y1: 221.175,
    y2: 364.7
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#ffcd3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#ffad2b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa325"
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c0272d"
  }))), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 310.981,
    x2: 353.5,
    xlinkHref: "#lg3",
    y1: 213.311,
    y2: 153.03
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 291.249,
    x2: 99.643,
    xlinkHref: "#lg3",
    y1: 237.086,
    y2: -59.293
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 193.19,
    x2: 112.458,
    xlinkHref: "#lg3",
    y1: 258.64,
    y2: 107.401
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 321.47,
    x2: 241.096,
    xlinkHref: "#lg3",
    y1: 301.117,
    y2: 149.698
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 143.709,
    x2: 79.123,
    xlinkHref: "#lg3",
    y1: 383.901,
    y2: 274.104
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bada00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2269,
    stopColor: "#b0ce00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6378,
    stopColor: "#95ae00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#798c00"
  }))), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 212.641,
    x2: 222.468,
    xlinkHref: "#lg4",
    y1: 193.464,
    y2: 217.276
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg5"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#798c00",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6542,
    stopColor: "#556100",
    stopOpacity: 0.654
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#464f00"
  }))), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientTransform: "matrix(-.999 -.055 .055 -.999 2457.648 -2337.984)",
    gradientUnits: "userSpaceOnUse",
    x1: 2096.318,
    x2: 2106.476,
    xlinkHref: "#lg5",
    y1: -2657.755,
    y2: -2643.672
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientTransform: "matrix(-.999 -.055 .055 -.999 2457.648 -2337.984)",
    gradientUnits: "userSpaceOnUse",
    x1: 2103.284,
    x2: 2111.304,
    xlinkHref: "#lg5",
    y1: -2666.649,
    y2: -2655.531
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientTransform: "matrix(-.999 -.055 .055 -.999 2457.648 -2337.984)",
    gradientUnits: "userSpaceOnUse",
    x1: 2091.57,
    x2: 2096.404,
    xlinkHref: "#lg5",
    y1: -2666.96,
    y2: -2660.257
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 117.549,
    x2: 127.376,
    xlinkHref: "#lg4",
    y1: 275.832,
    y2: 299.644
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientTransform: "matrix(-.999 -.055 .055 -.999 2457.648 -2337.984)",
    gradientUnits: "userSpaceOnUse",
    x1: 2186.728,
    x2: 2196.886,
    xlinkHref: "#lg5",
    y1: -2745.236,
    y2: -2731.153
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientTransform: "matrix(-.999 -.055 .055 -.999 2457.648 -2337.984)",
    gradientUnits: "userSpaceOnUse",
    x1: 2193.695,
    x2: 2201.714,
    xlinkHref: "#lg5",
    y1: -2754.13,
    y2: -2743.012
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientTransform: "matrix(-.999 -.055 .055 -.999 2457.648 -2337.984)",
    gradientUnits: "userSpaceOnUse",
    x1: 2181.98,
    x2: 2186.815,
    xlinkHref: "#lg5",
    y1: -2754.441,
    y2: -2747.738
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 235.925,
    x2: 245.752,
    xlinkHref: "#lg4",
    y1: 299.517,
    y2: 323.329
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientTransform: "matrix(-.999 -.055 .055 -.999 2457.648 -2337.984)",
    gradientUnits: "userSpaceOnUse",
    x1: 2067.227,
    x2: 2077.385,
    xlinkHref: "#lg5",
    y1: -2762.365,
    y2: -2748.282
  })), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientTransform: "matrix(-.999 -.055 .055 -.999 2457.648 -2337.984)",
    gradientUnits: "userSpaceOnUse",
    x1: 2074.194,
    x2: 2082.213,
    xlinkHref: "#lg5",
    y1: -2771.258,
    y2: -2760.141
  })), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientTransform: "matrix(-.999 -.055 .055 -.999 2457.648 -2337.984)",
    gradientUnits: "userSpaceOnUse",
    x1: 2062.479,
    x2: 2067.314,
    xlinkHref: "#lg5",
    y1: -2771.57,
    y2: -2764.867
  })), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 405.257,
    x2: 415.084,
    xlinkHref: "#lg4",
    y1: 245.964,
    y2: 269.775
  })), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientTransform: "matrix(-.999 -.055 .055 -.999 2457.648 -2337.984)",
    gradientUnits: "userSpaceOnUse",
    x1: 1901.102,
    x2: 1911.261,
    xlinkHref: "#lg5",
    y1: -2699.565,
    y2: -2685.482
  })), _linearGradient28 || (_linearGradient28 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientTransform: "matrix(-.999 -.055 .055 -.999 2457.648 -2337.984)",
    gradientUnits: "userSpaceOnUse",
    x1: 1908.069,
    x2: 1916.089,
    xlinkHref: "#lg5",
    y1: -2708.459,
    y2: -2697.341
  })), _linearGradient29 || (_linearGradient29 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientTransform: "matrix(-.999 -.055 .055 -.999 2457.648 -2337.984)",
    gradientUnits: "userSpaceOnUse",
    x1: 1896.354,
    x2: 1901.189,
    xlinkHref: "#lg5",
    y1: -2708.77,
    y2: -2702.067
  })), _linearGradient30 || (_linearGradient30 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 213.872,
    x2: 223.699,
    xlinkHref: "#lg4",
    y1: 97.255,
    y2: 121.067
  })), _linearGradient31 || (_linearGradient31 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientTransform: "matrix(-.999 -.055 .055 -.999 2457.648 -2337.984)",
    gradientUnits: "userSpaceOnUse",
    x1: 2100.388,
    x2: 2110.546,
    xlinkHref: "#lg5",
    y1: -2561.624,
    y2: -2547.541
  })), _linearGradient32 || (_linearGradient32 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientTransform: "matrix(-.999 -.055 .055 -.999 2457.648 -2337.984)",
    gradientUnits: "userSpaceOnUse",
    x1: 2107.354,
    x2: 2115.374,
    xlinkHref: "#lg5",
    y1: -2570.518,
    y2: -2559.4
  })), _linearGradient33 || (_linearGradient33 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientTransform: "matrix(-.999 -.055 .055 -.999 2457.648 -2337.984)",
    gradientUnits: "userSpaceOnUse",
    x1: 2095.639,
    x2: 2100.474,
    xlinkHref: "#lg5",
    y1: -2570.829,
    y2: -2564.127
  })), _linearGradient34 || (_linearGradient34 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg6"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdecf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3791,
    stopColor: "#fdc4b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7655,
    stopColor: "#fbae97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#faa68e"
  }))), _linearGradient35 || (_linearGradient35 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientTransform: "matrix(.707 .707 -.707 .707 -320.292 -784.641)",
    gradientUnits: "userSpaceOnUse",
    x1: 1026.071,
    x2: 1049.994,
    xlinkHref: "#lg6",
    y1: 252.617,
    y2: 301.482
  })), _linearGradient36 || (_linearGradient36 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientTransform: "matrix(-.707 -.707 .707 -.707 2186.543 -1089.263)",
    gradientUnits: "userSpaceOnUse",
    x1: 501.514,
    x2: 520.821,
    xlinkHref: "#lg6",
    y1: -2303.637,
    y2: -2264.201
  })), _linearGradient37 || (_linearGradient37 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg7"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a57c52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1339,
    stopColor: "#a26c4a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5155,
    stopColor: "#994336"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8174,
    stopColor: "#942a2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#922125"
  }))), _linearGradient38 || (_linearGradient38 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_31_",
    gradientUnits: "userSpaceOnUse",
    x1: 37.551,
    x2: 53.697,
    xlinkHref: "#lg7",
    y1: 367.031,
    y2: 393.404
  })), _linearGradient39 || (_linearGradient39 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_32_",
    gradientTransform: "matrix(.707 .707 -.707 .707 -320.292 -784.641)",
    gradientUnits: "userSpaceOnUse",
    x1: 1068.141,
    x2: 1088.561,
    xlinkHref: "#lg6",
    y1: 485.428,
    y2: 527.137
  })), _linearGradient40 || (_linearGradient40 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_33_",
    gradientTransform: "matrix(-.707 -.707 .707 -.707 2186.543 -1089.263)",
    gradientUnits: "userSpaceOnUse",
    x1: 463.781,
    x2: 480.261,
    xlinkHref: "#lg6",
    y1: -2527.219,
    y2: -2493.558
  })), _linearGradient41 || (_linearGradient41 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_34_",
    gradientUnits: "userSpaceOnUse",
    x1: 325.819,
    x2: 347.209,
    xlinkHref: "#lg7",
    y1: 273.758,
    y2: 309.281
  })), _linearGradient42 || (_linearGradient42 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg8"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff6359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2243,
    stopColor: "#fe5b50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5952,
    stopColor: "#fc4637"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f82814"
  }))), _linearGradient43 || (_linearGradient43 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_35_",
    gradientUnits: "userSpaceOnUse",
    x1: 315.495,
    x2: 334.154,
    xlinkHref: "#lg8",
    y1: 219.916,
    y2: 265.127
  })), _linearGradient44 || (_linearGradient44 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_36_",
    gradientTransform: "matrix(-.999 -.055 .055 -.999 2457.648 -2337.984)",
    gradientUnits: "userSpaceOnUse",
    x1: 1986.911,
    x2: 2006.199,
    xlinkHref: "#lg2",
    y1: -2684.334,
    y2: -2657.595
  })), _linearGradient45 || (_linearGradient45 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_37_",
    gradientTransform: "matrix(-.999 -.055 .055 -.999 2457.648 -2337.984)",
    gradientUnits: "userSpaceOnUse",
    x1: 2000.139,
    x2: 2015.365,
    xlinkHref: "#lg2",
    y1: -2701.22,
    y2: -2680.111
  })), _linearGradient46 || (_linearGradient46 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_38_",
    gradientTransform: "matrix(-.999 -.055 .055 -.999 2457.648 -2337.984)",
    gradientUnits: "userSpaceOnUse",
    x1: 1977.897,
    x2: 1987.076,
    xlinkHref: "#lg2",
    y1: -2701.811,
    y2: -2689.085
  })), _linearGradient47 || (_linearGradient47 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_39_",
    gradientUnits: "userSpaceOnUse",
    x1: 131.577,
    x2: 150.235,
    xlinkHref: "#lg8",
    y1: 300.988,
    y2: 346.199
  })), _linearGradient48 || (_linearGradient48 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_40_",
    gradientTransform: "matrix(-.999 -.055 .055 -.999 2457.648 -2337.984)",
    gradientUnits: "userSpaceOnUse",
    x1: 2166.085,
    x2: 2185.372,
    xlinkHref: "#lg2",
    y1: -2775.413,
    y2: -2748.674
  })), _linearGradient49 || (_linearGradient49 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_41_",
    gradientTransform: "matrix(-.999 -.055 .055 -.999 2457.648 -2337.984)",
    gradientUnits: "userSpaceOnUse",
    x1: 2179.313,
    x2: 2194.539,
    xlinkHref: "#lg2",
    y1: -2792.3,
    y2: -2771.191
  })), _linearGradient50 || (_linearGradient50 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_42_",
    gradientTransform: "matrix(-.999 -.055 .055 -.999 2457.648 -2337.984)",
    gradientUnits: "userSpaceOnUse",
    x1: 2157.07,
    x2: 2166.25,
    xlinkHref: "#lg2",
    y1: -2792.89,
    y2: -2780.164
  })), _linearGradient51 || (_linearGradient51 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_43_",
    gradientUnits: "userSpaceOnUse",
    x1: 219.835,
    x2: 241.226,
    xlinkHref: "#lg7",
    y1: 234.622,
    y2: 270.145
  })), _linearGradient52 || (_linearGradient52 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_44_",
    gradientUnits: "userSpaceOnUse",
    x1: 258.257,
    x2: 215.558,
    xlinkHref: "#lg5",
    y1: 334.97,
    y2: 254.237
  })), _linearGradient53 || (_linearGradient53 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_45_",
    gradientTransform: "matrix(.707 .707 -.707 .707 -320.292 -784.641)",
    gradientUnits: "userSpaceOnUse",
    x1: 1139.515,
    x2: 1159.935,
    xlinkHref: "#lg6",
    y1: 312.033,
    y2: 353.742
  })), _linearGradient54 || (_linearGradient54 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_46_",
    gradientTransform: "matrix(-.707 -.707 .707 -.707 2186.543 -1089.263)",
    gradientUnits: "userSpaceOnUse",
    x1: 392.407,
    x2: 408.886,
    xlinkHref: "#lg6",
    y1: -2353.823,
    y2: -2320.163
  })), _linearGradient55 || (_linearGradient55 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg9"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8a7889"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3344,
    stopColor: "#867385"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#7b667b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6e566e"
  }))), _linearGradient56 || (_linearGradient56 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_47_",
    gradientUnits: "userSpaceOnUse",
    x1: 68.016,
    x2: 77.231,
    xlinkHref: "#lg9",
    y1: 276.665,
    y2: 295.095
  })), _linearGradient57 || (_linearGradient57 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_48_",
    gradientUnits: "userSpaceOnUse",
    x1: 168.869,
    x2: 178.084,
    xlinkHref: "#lg9",
    y1: 249.042,
    y2: 267.472
  })), _linearGradient58 || (_linearGradient58 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_49_",
    gradientUnits: "userSpaceOnUse",
    x1: 297.307,
    x2: 306.522,
    xlinkHref: "#lg9",
    y1: 177.725,
    y2: 196.155
  })), _linearGradient59 || (_linearGradient59 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_50_",
    gradientUnits: "userSpaceOnUse",
    x1: 28.65,
    x2: 37.865,
    xlinkHref: "#lg9",
    y1: 386.776,
    y2: 405.206
  })), _linearGradient60 || (_linearGradient60 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_51_",
    gradientUnits: "userSpaceOnUse",
    x1: 136.205,
    x2: 154.863,
    xlinkHref: "#lg8",
    y1: 194.388,
    y2: 239.599
  })), _linearGradient61 || (_linearGradient61 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_52_",
    gradientTransform: "matrix(-.999 -.055 .055 -.999 2457.648 -2337.984)",
    gradientUnits: "userSpaceOnUse",
    x1: 2167.336,
    x2: 2186.623,
    xlinkHref: "#lg2",
    y1: -2668.721,
    y2: -2641.981
  })), _linearGradient62 || (_linearGradient62 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_53_",
    gradientTransform: "matrix(-.999 -.055 .055 -.999 2457.648 -2337.984)",
    gradientUnits: "userSpaceOnUse",
    x1: 2180.564,
    x2: 2195.79,
    xlinkHref: "#lg2",
    y1: -2685.607,
    y2: -2664.498
  })), _linearGradient63 || (_linearGradient63 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_54_",
    gradientTransform: "matrix(-.999 -.055 .055 -.999 2457.648 -2337.984)",
    gradientUnits: "userSpaceOnUse",
    x1: 2158.322,
    x2: 2167.501,
    xlinkHref: "#lg2",
    y1: -2686.198,
    y2: -2673.471
  })), _linearGradient64 || (_linearGradient64 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_55_",
    gradientUnits: "userSpaceOnUse",
    x1: 286.486,
    x2: 307.876,
    xlinkHref: "#lg7",
    y1: 141.905,
    y2: 177.428
  })), _linearGradient65 || (_linearGradient65 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_56_",
    gradientUnits: "userSpaceOnUse",
    x1: 372.801,
    x2: 335.484,
    xlinkHref: "#lg1",
    y1: 132.371,
    y2: 193.369
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m224.004 97.902s-154.935 94.788-212.219 352.387c-4.263 19.169 17.652 33.327 33.345 21.523 68.68-51.657 214.684-143.912 416.708-177.075 23.027-3.78 34.652-29.762 22.126-49.451-30.516-47.966-101.971-121.806-259.96-147.384z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m483.587 244.701c-221.979 26.98-382.24 127.674-455.209 182.557-3.842 2.89-8.056 4.218-12.168 4.308-1.529 6.162-3.019 12.394-4.433 18.754-4.259 19.157 17.669 33.288 33.353 21.492 68.692-51.666 214.736-143.945 416.815-177.092 22.892-3.755 34.565-29.668 22.131-49.252-.162-.255-.325-.511-.489-.767z",
    fill: "url(#SVGID_2_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m492.111 263.798s-40.352-144.853-281.818-178.329c0 0-154.223 93.471-209.785 341.469-4.136 18.463 17.857 31.644 33.471 20.058 5.961-4.423 12.508-9.152 19.629-14.123 8.914-6.224 21.153.164 21.153 11.035v.774c0 11.494 9.317 20.811 20.811 20.811 11.494 0 20.811-9.317 20.811-20.811v-21.801c0-18.931 10.331-36.35 26.953-45.41 40.68-22.175 88.863-44.774 143.804-64.381 8.758-3.125 17.978 3.378 17.978 12.678 0 11.494 9.317 20.811 20.811 20.811 11.494 0 20.811-9.317 20.811-20.811v-26.786c0-3.013 2.004-5.658 4.904-6.474l.136-.038c4.314-1.214 8.594 2.029 8.594 6.51v67.814c0 11.494 9.317 20.811 20.811 20.811 11.494 0 20.811-9.317 20.811-20.811v-57.874c0-17.164 12.121-31.995 28.971-35.265 19.819-3.845 40.207-7.163 61.144-9.857z",
    fill: "url(#SVGID_3_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m210.293 85.47s-29.447 17.849-67.241 58.636l196.957 196.957c4.129-3.803 6.732-9.238 6.732-15.294v-26.786c0-3.013 2.004-5.658 4.904-6.474l.136-.038c4.314-1.214 8.594 2.029 8.594 6.51v62.449l25.6 25.6c9.181-2.166 16.022-10.393 16.022-20.235v-57.875c0-17.164 12.121-31.995 28.971-35.265 19.818-3.846 40.205-7.164 61.142-9.857.001 0-40.351-144.853-281.817-178.328z",
    fill: "url(#SVGID_4_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m260.623 134.097c-2.042-2.313-4.412-4.511-7.118-6.552-22.066-16.64-57.843-16.64-79.909 0-20.918 15.774-21.992 40.833-3.251 57.574l160.78 160.78c8.975-2.311 15.616-10.435 15.616-20.131v-26.786c0-3.013 2.004-5.658 4.904-6.474l.136-.038c4.314-1.214 8.594 2.029 8.594 6.51v67.814c0 4.978 1.753 9.544 4.668 13.126 1.418 1.47 2.983 2.884 4.682 4.238 3.288 2.174 7.224 3.448 11.46 3.448 11.494 0 20.811-9.317 20.811-20.811v-57.875c0-9.193 3.48-17.714 9.298-24.151z",
    fill: "url(#SVGID_5_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m182.763 200.974c-7.652-8.847-21.473-14.755-37.253-14.755-24.077 0-43.596 13.752-43.596 30.717 0 7.241 3.565 13.892 9.514 19.143l104.99 105.32c22.133-9.84 45.72-19.386 70.723-28.309 2.297-.82 4.622-.963 6.808-.581z",
    fill: "url(#SVGID_6_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m361.524 225.92c-7.749-8.52-21.295-14.172-36.723-14.172-24.077 0-43.596 13.752-43.596 30.717 0 .693.044 1.378.108 2.059-18.814-9.95-44.938-8.597-61.747 4.079-17.696 13.345-18.763 34.478-3.206 48.765l30.913 30.913c12.86-5.214 26.153-10.295 39.867-15.189 8.758-3.125 17.978 3.378 17.978 12.678 0 11.494 9.317 20.811 20.811 20.811 11.494 0 20.811-9.317 20.811-20.811v-26.786c0-3.013 2.004-5.658 4.904-6.474l.136-.038c4.314-1.214 8.594 2.029 8.594 6.51v67.814c0 11.494 9.317 20.811 20.811 20.811 11.494 0 20.811-9.317 20.811-20.811v-57.876c0-11.461 5.41-21.876 14.018-28.509z",
    fill: "url(#SVGID_7_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m213.374 342.76-35.767-35.767c-7.748-8.521-21.295-14.174-36.725-14.174-18.887 0-34.965 8.464-41.02 20.301-17.644-5.795-38.943-3.261-53.374 7.622-17.697 13.345-18.763 34.479-3.205 48.765l73.101 73.101v-19.725c0-18.931 10.331-36.35 26.953-45.41 21.314-11.621 44.709-23.352 70.037-34.713z",
    fill: "url(#SVGID_8_)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#ffeaa2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m97.779 255.867c.959-1.808.271-4.051-1.536-5.01-1.808-.959-4.051-.271-5.01 1.536-.959 1.808-.271 4.051 1.536 5.01 1.807.96 4.05.272 5.01-1.536z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m85.613 257.361c-1.427-.757-3.198-.214-3.955 1.213s-.214 3.198 1.213 3.955 3.198.214 3.955-1.213c.757-1.428.214-3.198-1.213-3.955z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m88.828 272.612c-.86-.456-1.928-.129-2.384.731s-.129 1.928.731 2.384c.86.457 1.928.129 2.384-.731.457-.86.13-1.927-.731-2.384z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m114.116 277.483c-2.046-.058-3.751 1.554-3.808 3.599-.058 2.046 1.554 3.751 3.599 3.808 2.046.058 3.751-1.554 3.808-3.599.058-2.046-1.553-3.751-3.599-3.808z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m133.395 251.272c-1.615-.046-2.961 1.227-3.006 2.841-.046 1.615 1.227 2.961 2.841 3.007 1.615.046 2.961-1.227 3.007-2.842.045-1.615-1.227-2.961-2.842-3.006z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m106.219 252.383c-.974-.027-1.785.74-1.813 1.713-.027.974.74 1.785 1.713 1.813.974.027 1.785-.74 1.813-1.713.028-.974-.739-1.785-1.713-1.813z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m100.401 267.575c-1.474.336-2.397 1.803-2.062 3.278.336 1.474 1.803 2.397 3.278 2.062 1.474-.336 2.397-1.803 2.062-3.278-.337-1.474-1.804-2.397-3.278-2.062z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m103.466 259.931c-1.164.265-1.893 1.424-1.628 2.588s1.424 1.893 2.588 1.628 1.893-1.424 1.628-2.588c-.266-1.164-1.424-1.893-2.588-1.628z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m94.678 264.16c.702-.16 1.141-.858.981-1.56s-.858-1.141-1.56-.981-1.141.858-.981 1.56.858 1.141 1.56.981z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m166.472 244.922c.959-1.808.271-4.051-1.536-5.01-1.808-.959-4.051-.271-5.01 1.536-.959 1.808-.271 4.051 1.536 5.01 1.808.959 4.051.271 5.01-1.536z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m148.534 276.788c-1.427-.757-3.198-.214-3.955 1.213s-.214 3.198 1.213 3.955 3.198.214 3.955-1.213.214-3.198-1.213-3.955z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m143.907 260.694c-.86-.457-1.928-.129-2.384.731s-.129 1.928.731 2.384c.86.457 1.928.129 2.384-.731s.129-1.927-.731-2.384z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m186.653 249.921c-2.046-.058-3.751 1.554-3.808 3.599-.058 2.046 1.554 3.751 3.599 3.808 2.046.058 3.751-1.554 3.808-3.599.058-2.045-1.553-3.75-3.599-3.808z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m186.243 244.975c.046-1.615-1.227-2.961-2.842-3.006s-2.961 1.227-3.006 2.841c-.046 1.615 1.227 2.961 2.841 3.007 1.615.045 2.961-1.227 3.007-2.842z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m174.913 241.437c-.974-.027-1.785.739-1.813 1.713-.027.974.74 1.785 1.713 1.813.974.027 1.785-.74 1.813-1.713.027-.974-.74-1.785-1.713-1.813z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m158.935 267.033c-1.474.336-2.397 1.803-2.062 3.278.336 1.474 1.803 2.397 3.278 2.062 1.474-.336 2.397-1.803 2.062-3.278-.336-1.475-1.803-2.398-3.278-2.062z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m172.159 248.985c-1.164.265-1.893 1.424-1.628 2.587.265 1.164 1.424 1.893 2.587 1.628 1.164-.265 1.893-1.424 1.628-2.587-.264-1.164-1.423-1.893-2.587-1.628z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m163.372 253.215c.702-.16 1.141-.858.981-1.56s-.858-1.141-1.56-.981-1.141.858-.981 1.56c.159.701.858 1.141 1.56.981z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m204.891 304.37c.959-1.808.271-4.051-1.536-5.01-1.808-.959-4.051-.271-5.01 1.536-.959 1.808-.271 4.051 1.536 5.01 1.808.96 4.051.272 5.01-1.536z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m192.725 305.864c-1.427-.757-3.198-.214-3.955 1.213s-.214 3.198 1.213 3.955 3.198.214 3.955-1.213c.758-1.428.214-3.198-1.213-3.955z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m195.941 321.115c-.86-.456-1.928-.129-2.384.731s-.129 1.928.731 2.384 1.928.129 2.384-.731.129-1.927-.731-2.384z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m221.229 325.986c-2.046-.058-3.751 1.554-3.808 3.599-.058 2.046 1.554 3.751 3.599 3.808 2.046.058 3.751-1.554 3.808-3.599s-1.554-3.751-3.599-3.808z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m386.914 242.465c-.691-1.46-2.436-2.083-3.896-1.392s-2.083 2.436-1.392 3.896c.692 1.46 2.436 2.083 3.896 1.392s2.084-2.436 1.392-3.896z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m213.332 300.886c-.974-.027-1.785.74-1.813 1.713-.027.974.74 1.785 1.713 1.813.974.027 1.785-.74 1.813-1.713.027-.974-.74-1.785-1.713-1.813z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m207.513 316.078c-1.474.336-2.397 1.803-2.062 3.278.336 1.474 1.803 2.397 3.278 2.062 1.474-.336 2.397-1.803 2.062-3.278s-1.804-2.397-3.278-2.062z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m210.578 308.434c-1.164.265-1.893 1.424-1.628 2.588s1.424 1.893 2.587 1.628c1.164-.265 1.893-1.424 1.628-2.588s-1.423-1.893-2.587-1.628z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m201.79 312.663c.702-.16 1.141-.858.981-1.56s-.858-1.141-1.56-.981-1.141.858-.981 1.56.859 1.141 1.56.981z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m205.15 142.725c.959-1.808.271-4.051-1.536-5.01-1.808-.959-4.051-.271-5.01 1.536-.959 1.808-.271 4.051 1.536 5.01 1.808.96 4.051.272 5.01-1.536z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m371.033 267.526c.028-1.615-1.259-2.947-2.874-2.975s-2.947 1.259-2.975 2.874 1.259 2.947 2.874 2.975 2.947-1.258 2.975-2.874z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m383.28 256.106c.017-.974-.759-1.777-1.733-1.794s-1.777.759-1.794 1.733.759 1.777 1.733 1.794 1.777-.759 1.794-1.733z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m225.331 147.724c-2.046-.058-3.751 1.554-3.808 3.599-.058 2.046 1.554 3.751 3.599 3.808 2.046.058 3.751-1.554 3.808-3.599.058-2.045-1.554-3.75-3.599-3.808z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m224.921 142.778c.046-1.615-1.227-2.961-2.842-3.006-1.615-.046-2.961 1.227-3.006 2.841-.046 1.615 1.227 2.961 2.841 3.007 1.615.045 2.961-1.227 3.007-2.842z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m213.59 139.241c-.974-.027-1.785.739-1.813 1.713-.027.974.74 1.785 1.713 1.813.974.027 1.785-.74 1.813-1.713.028-.974-.739-1.786-1.713-1.813z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m384.443 272.376c-.968-1.162-2.694-1.319-3.856-.352-1.162.968-1.319 2.694-.352 3.856.968 1.162 2.694 1.319 3.856.352 1.162-.968 1.32-2.694.352-3.856z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m210.837 146.789c-1.164.265-1.893 1.424-1.628 2.587.265 1.164 1.424 1.893 2.588 1.628s1.893-1.424 1.628-2.587c-.266-1.165-1.424-1.893-2.588-1.628z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m202.049 151.018c.702-.16 1.141-.858.981-1.56s-.858-1.141-1.56-.981-1.141.858-.981 1.56.858 1.141 1.56.981z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m306.242 219.507c-1.087 1.734-.563 4.021 1.171 5.108s4.021.563 5.108-1.171.563-4.021-1.171-5.107c-1.734-1.088-4.021-.564-5.108 1.17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m318.484 218.895c1.369.858 3.174.444 4.032-.925s.444-3.174-.925-4.032-3.174-.444-4.032.925-.444 3.174.925 4.032z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m316.377 203.451c.825.517 1.914.268 2.431-.558.517-.825.268-1.914-.557-2.431s-1.914-.268-2.431.557c-.518.826-.268 1.915.557 2.432z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m291.506 196.77c2.036.205 3.853-1.279 4.058-3.315s-1.279-3.853-3.315-4.058-3.853 1.279-4.058 3.315c-.206 2.037 1.279 3.853 3.315 4.058z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m270.387 221.523c1.607.162 3.042-1.01 3.204-2.617s-1.01-3.042-2.617-3.204-3.042 1.01-3.204 2.617c-.162 1.608 1.01 3.042 2.617 3.204z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m297.573 222.374c.969.098 1.834-.609 1.931-1.578.098-.969-.609-1.834-1.578-1.931-.969-.098-1.834.609-1.931 1.578-.098.968.609 1.833 1.578 1.931z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m304.471 207.64c1.495-.229 2.521-1.626 2.293-3.12-.229-1.495-1.626-2.521-3.12-2.293-1.495.229-2.521 1.626-2.293 3.12.229 1.496 1.626 2.522 3.12 2.293z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m300.863 215.044c1.18-.181 1.99-1.283 1.81-2.463s-1.283-1.99-2.463-1.81-1.99 1.283-1.81 2.463 1.283 1.99 2.463 1.81z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m309.933 211.459c-.711.109-1.2.774-1.091 1.485s.774 1.2 1.485 1.091 1.2-.774 1.091-1.485-.774-1.2-1.485-1.091z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m236.939 225.472c-1.087 1.734-.563 4.021 1.171 5.108s4.021.563 5.107-1.171c1.087-1.734.563-4.021-1.171-5.108-1.734-1.088-4.02-.563-5.107 1.171z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m257.128 194.982c1.369.858 3.174.444 4.032-.925s.444-3.174-.925-4.032-3.174-.444-4.032.925c-.858 1.368-.444 3.173.925 4.032z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m260.582 211.367c.825.517 1.914.268 2.431-.558.517-.825.268-1.914-.558-2.431-.825-.517-1.914-.268-2.431.557-.516.826-.267 1.915.558 2.432z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m217.171 219.031c2.036.205 3.853-1.279 4.058-3.315s-1.279-3.853-3.315-4.058-3.853 1.279-4.058 3.315c-.206 2.036 1.279 3.853 3.315 4.058z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m217.223 223.993c-.162 1.607 1.01 3.042 2.617 3.203 1.607.162 3.042-1.01 3.203-2.617.162-1.607-1.01-3.042-2.617-3.204-1.607-.161-3.041 1.011-3.203 2.618z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m228.269 228.338c.969.098 1.834-.609 1.931-1.578.098-.969-.609-1.834-1.578-1.931-.969-.098-1.834.609-1.931 1.578-.098.969.609 1.834 1.578 1.931z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m246.05 203.961c1.495-.229 2.521-1.626 2.293-3.12-.229-1.495-1.626-2.521-3.12-2.293-1.495.229-2.521 1.626-2.293 3.12.228 1.495 1.625 2.522 3.12 2.293z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m231.559 221.009c1.18-.181 1.99-1.283 1.81-2.463s-1.283-1.99-2.463-1.81c-1.18.181-1.99 1.283-1.81 2.463s1.283 1.99 2.463 1.81z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m240.629 217.424c-.711.109-1.2.774-1.091 1.485.109.712.774 1.2 1.485 1.091s1.2-.774 1.091-1.485-.774-1.2-1.485-1.091z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m96.059 395.195c-.29 2.026 1.117 3.903 3.143 4.193s3.903-1.117 4.193-3.143-1.117-3.903-3.143-4.193c-2.026-.289-3.903 1.118-4.193 3.143z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m106.999 389.67c1.599.229 3.081-.882 3.31-2.481s-.882-3.081-2.481-3.31-3.081.882-3.31 2.481c-.229 1.598.882 3.081 2.481 3.31z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m98.807 376.409c.964.138 1.858-.532 1.996-1.496s-.532-1.858-1.496-1.996-1.858.532-1.996 1.496c-.137.964.532 1.858 1.496 1.996z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m73.365 380.393c1.944-.639 3.003-2.732 2.364-4.677-.639-1.944-2.732-3.003-4.677-2.364-1.944.639-3.003 2.732-2.364 4.677.639 1.944 2.732 3.003 4.677 2.364z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m64.105 411.585c1.535-.504 2.37-2.157 1.866-3.692s-2.157-2.37-3.692-1.866-2.37 2.157-1.866 3.692c.504 1.534 2.157 2.37 3.692 1.866z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m89.297 401.333c.925-.304 1.429-1.301 1.125-2.226s-1.301-1.429-2.226-1.125-1.429 1.301-1.125 2.226 1.301 1.429 2.226 1.125z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m89.625 385.068c1.273-.815 1.645-2.509.829-3.782-.815-1.273-2.509-1.645-3.782-.829-1.273.815-1.645 2.509-.829 3.782s2.509 1.644 3.782.829z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m89.331 393.299c1.005-.644 1.299-1.981.655-2.986s-1.981-1.299-2.986-.655-1.299 1.981-.655 2.986 1.981 1.298 2.986.655z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m96.166 386.342c-.606.388-.783 1.194-.395 1.8s1.194.783 1.8.395.783-1.194.395-1.8c-.387-.606-1.193-.783-1.8-.395z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35.134 428.764c-.29 2.026 1.117 3.903 3.143 4.193s3.903-1.117 4.193-3.143-1.117-3.903-3.143-4.193c-2.025-.29-3.902 1.117-4.193 3.143z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m41.217 392.705c1.599.229 3.081-.882 3.31-2.481s-.882-3.081-2.481-3.31-3.081.882-3.31 2.481.882 3.081 2.481 3.31z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m51.023 406.28c.964.138 1.858-.532 1.996-1.496s-.532-1.858-1.496-1.996-1.858.532-1.996 1.496.532 1.858 1.496 1.996z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.453 430.897c1.944-.639 3.002-2.732 2.364-4.677-.639-1.944-2.732-3.003-4.677-2.364-1.944.639-3.003 2.732-2.364 4.677.639 1.944 2.733 3.003 4.677 2.364z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.514 435.412c.504 1.535 2.157 2.37 3.692 1.866s2.37-2.157 1.866-3.692-2.157-2.37-3.692-1.866c-1.534.504-2.37 2.157-1.866 3.692z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.373 434.902c.925-.304 1.429-1.3 1.125-2.226-.304-.925-1.301-1.429-2.226-1.125s-1.429 1.301-1.125 2.226 1.301 1.429 2.226 1.125z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m34.735 405.407c1.273-.815 1.645-2.509.829-3.782-.815-1.273-2.509-1.645-3.782-.829-1.273.815-1.645 2.509-.829 3.782.815 1.273 2.509 1.644 3.782.829z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.407 426.867c1.005-.644 1.299-1.98.655-2.986-.644-1.005-1.981-1.298-2.986-.655-1.005.644-1.299 1.98-.655 2.986s1.981 1.299 2.986.655z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35.242 419.911c-.606.388-.783 1.194-.395 1.8s1.194.783 1.8.395.783-1.194.395-1.8-1.194-.783-1.8-.395z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 217.542,
    cy: 205.34,
    fill: "url(#SVGID_9_)",
    rx: 22.961,
    ry: 16.178
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 215.104,
    cy: 195.563,
    fill: "url(#SVGID_10_)",
    r: 3.669
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 208.293,
    cy: 205.05,
    fill: "url(#SVGID_11_)",
    r: 2.896
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 220.917,
    cy: 207.48,
    fill: "url(#SVGID_12_)",
    r: 1.746
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 122.45,
    cy: 287.708,
    fill: "url(#SVGID_13_)",
    rx: 22.961,
    ry: 16.178
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 120.013,
    cy: 277.931,
    fill: "url(#SVGID_14_)",
    r: 3.669
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 113.201,
    cy: 287.418,
    fill: "url(#SVGID_15_)",
    r: 2.896
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 125.826,
    cy: 289.848,
    fill: "url(#SVGID_16_)",
    r: 1.746
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 240.826,
    cy: 311.393,
    fill: "url(#SVGID_17_)",
    rx: 22.961,
    ry: 16.178
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 238.389,
    cy: 301.616,
    fill: "url(#SVGID_18_)",
    r: 3.669
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231.577,
    cy: 311.103,
    fill: "url(#SVGID_19_)",
    r: 2.896
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 244.201,
    cy: 313.533,
    fill: "url(#SVGID_20_)",
    r: 1.746
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 410.158,
    cy: 257.839,
    fill: "url(#SVGID_21_)",
    rx: 22.961,
    ry: 16.178
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 407.72,
    cy: 248.063,
    fill: "url(#SVGID_22_)",
    r: 3.669
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 400.909,
    cy: 257.55,
    fill: "url(#SVGID_23_)",
    r: 2.896
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 413.533,
    cy: 259.98,
    fill: "url(#SVGID_24_)",
    r: 1.746
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 218.773,
    cy: 109.131,
    fill: "url(#SVGID_25_)",
    rx: 22.961,
    ry: 16.178
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 216.336,
    cy: 99.354,
    fill: "url(#SVGID_26_)",
    r: 3.669
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 209.524,
    cy: 108.841,
    fill: "url(#SVGID_27_)",
    r: 2.896
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 222.148,
    cy: 111.271,
    fill: "url(#SVGID_28_)",
    r: 1.746
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m253.506 127.545c-22.066-16.64-57.843-16.64-79.909 0s-22.066 43.619 0 60.259 57.843 16.64 79.909 0 22.066-43.619 0-60.259zm-65.327 40.963c-14.011-9.229-14.011-24.196 0-33.424 14.011-9.229 36.728-9.225 50.739.004s14.016 24.192.006 33.42c-14.012 9.229-36.735 9.229-50.745 0z",
    fill: "url(#SVGID_29_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m180.316 178.403c18.353 13.341 48.118 13.341 66.47 0 18.358-13.345 18.353-34.977 0-48.317-18.358-13.345-48.112-13.345-66.47 0-18.353 13.34-18.359 34.972 0 48.317zm58.607-43.319c14.011 9.229 14.011 24.196 0 33.424-14.011 9.229-36.728 9.225-50.739-.004s-14.016-24.192-.006-33.42c14.012-9.228 36.734-9.228 50.745 0z",
    fill: "url(#SVGID_30_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m31.938 384.726c8.266 3.191 18.807.826 23.545-5.282.932-1.202.519-2.614-.779-4.061-1.435-1.6-.92-3.711 1.05-4.999l.333-.217c2.545-1.664 1.962-4.602-1.135-5.712l-12.325-4.417c-3.097-1.11-6.82.284-7.239 2.71-.323 1.87-2.499 3.318-5.173 3.427-2.139.087-3.812.611-4.665 1.711-4.739 6.11-1.878 13.649 6.388 16.84z",
    fill: "url(#SVGID_31_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m114.695 320.742c-18.835-14.203-49.372-14.203-68.207 0s-18.835 37.231 0 51.434 49.372 14.203 68.207 0c18.834-14.203 18.834-37.231 0-51.434zm-55.761 34.964c-11.959-7.877-11.959-20.652 0-28.529s31.349-7.874 43.308.003 11.964 20.649.005 28.526c-11.958 7.877-31.354 7.877-43.313 0z",
    fill: "url(#SVGID_32_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m52.223 364.151c15.665 11.387 41.071 11.387 56.736 0 15.67-11.39 15.665-29.855 0-41.242-15.67-11.39-41.066-11.39-56.736 0-15.665 11.388-15.67 29.852 0 41.242zm50.025-36.975c11.959 7.877 11.959 20.652 0 28.529s-31.349 7.874-43.308-.003-11.964-20.649-.005-28.526c11.958-7.877 31.354-7.877 43.313 0z",
    fill: "url(#SVGID_33_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m339.744 269.773c-8.266-3.191-18.807-.826-23.545 5.282-.932 1.202-.519 2.614.779 4.061 1.435 1.6.92 3.711-1.05 4.999l-.333.217c-2.545 1.664-1.962 4.602 1.135 5.712l12.325 4.417c3.097 1.11 6.82-.284 7.239-2.71.323-1.87 2.499-3.318 5.173-3.427 2.139-.087 3.812-.611 4.665-1.711 4.739-6.11 1.878-13.649-6.388-16.84z",
    fill: "url(#SVGID_34_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 324.801,
    cy: 242.464,
    fill: "url(#SVGID_35_)",
    rx: 43.596,
    ry: 30.717
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 320.173,
    cy: 223.902,
    fill: "url(#SVGID_36_)",
    r: 6.965
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 307.24,
    cy: 241.914,
    fill: "url(#SVGID_37_)",
    r: 5.499
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 331.209,
    cy: 246.528,
    fill: "url(#SVGID_38_)",
    r: 3.315
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 140.882,
    cy: 323.536,
    fill: "url(#SVGID_39_)",
    rx: 43.596,
    ry: 30.717
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 136.254,
    cy: 304.974,
    fill: "url(#SVGID_40_)",
    r: 6.965
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 123.322,
    cy: 322.986,
    fill: "url(#SVGID_41_)",
    r: 5.499
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 147.291,
    cy: 327.6,
    fill: "url(#SVGID_42_)",
    r: 3.315
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m233.761 230.637c-8.266-3.191-18.807-.826-23.545 5.282-.932 1.202-.519 2.614.779 4.061 1.435 1.6.92 3.711-1.05 4.999l-.333.217c-2.545 1.664-1.962 4.602 1.135 5.712l12.325 4.417c3.097 1.11 6.82-.284 7.239-2.71.323-1.87 2.499-3.318 5.173-3.427 2.139-.087 3.812-.611 4.665-1.711 4.738-6.109 1.878-13.648-6.388-16.84z",
    fill: "url(#SVGID_43_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m246.117 327.122c10.126-1.686 17.671-8.08 17.671-15.73 0-8.935-10.28-16.178-22.961-16.178-8.068 0-15.15 2.938-19.246 7.372z",
    fill: "url(#SVGID_44_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m287.773 248.602c-18.835-14.203-49.372-14.203-68.207 0s-18.835 37.231 0 51.434 49.372 14.203 68.207 0 18.835-37.231 0-51.434zm-55.76 34.964c-11.959-7.877-11.959-20.652 0-28.529s31.349-7.874 43.308.003 11.964 20.649.005 28.526-31.354 7.877-43.313 0z",
    fill: "url(#SVGID_45_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m225.302 292.011c15.665 11.387 41.071 11.387 56.736 0 15.67-11.39 15.665-29.855 0-41.242-15.67-11.39-41.066-11.39-56.736 0-15.665 11.388-15.67 29.852 0 41.242zm50.024-36.974c11.959 7.877 11.959 20.652 0 28.529s-31.349 7.874-43.308-.003-11.964-20.649-.005-28.526c11.959-7.878 31.354-7.878 43.313 0z",
    fill: "url(#SVGID_46_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m76.093 278.646c-10.99 0-19.899 6.345-19.899 14.173s8.909 14.173 19.899 14.173 19.899-6.345 19.899-14.173-8.909-14.173-19.899-14.173zm0 20.189c-4.665 0-8.446-2.693-8.446-6.016 0-3.322 3.781-6.016 8.446-6.016s8.446 2.693 8.446 6.016c.001 3.323-3.781 6.016-8.446 6.016z",
    fill: "url(#SVGID_47_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m176.946 251.023c-10.99 0-19.899 6.345-19.899 14.173s8.909 14.173 19.899 14.173 19.899-6.345 19.899-14.173-8.91-14.173-19.899-14.173zm0 20.188c-4.665 0-8.446-2.693-8.446-6.016 0-3.322 3.781-6.016 8.446-6.016s8.446 2.693 8.446 6.016-3.782 6.016-8.446 6.016z",
    fill: "url(#SVGID_48_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m305.384 179.706c-10.99 0-19.899 6.345-19.899 14.173s8.909 14.173 19.899 14.173 19.899-6.345 19.899-14.173-8.909-14.173-19.899-14.173zm0 20.189c-4.665 0-8.446-2.693-8.446-6.016s3.781-6.016 8.446-6.016 8.446 2.693 8.446 6.016-3.781 6.016-8.446 6.016z",
    fill: "url(#SVGID_49_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36.727 388.757c-10.99 0-19.899 6.345-19.899 14.173s8.909 14.173 19.899 14.173 19.899-6.345 19.899-14.173-8.909-14.173-19.899-14.173zm0 20.188c-4.665 0-8.446-2.693-8.446-6.016 0-3.322 3.781-6.016 8.446-6.016s8.446 2.693 8.446 6.016-3.781 6.016-8.446 6.016z",
    fill: "url(#SVGID_50_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 145.51,
    cy: 216.936,
    fill: "url(#SVGID_51_)",
    rx: 43.596,
    ry: 30.717
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 140.882,
    cy: 198.374,
    fill: "url(#SVGID_52_)",
    r: 6.965
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 127.949,
    cy: 216.386,
    fill: "url(#SVGID_53_)",
    r: 5.499
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 151.918,
    cy: 221,
    fill: "url(#SVGID_54_)",
    r: 3.315
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m300.412 137.921c-8.266-3.191-18.807-.826-23.545 5.282-.932 1.202-.519 2.614.779 4.061 1.435 1.6.92 3.711-1.05 4.999l-.333.217c-2.545 1.664-1.962 4.602 1.135 5.712l12.325 4.417c3.097 1.11 6.82-.284 7.239-2.71.323-1.87 2.499-3.318 5.173-3.427 2.139-.087 3.812-.611 4.665-1.711 4.738-6.11 1.878-13.649-6.388-16.84z",
    fill: "url(#SVGID_55_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m214.791 104.324c37.402 14.219 72.773 35.326 118.083 68.607s80.168 83.109 106.031 115.36c13.893 17.324 52.144 14.175 64.776-5.563 8.435-13.181 8.461-39.811-.135-52.002-25.362-35.97-68.071-78.226-120.825-116.975s-104.941-66.195-145.4-78.572c-13.712-4.195-28.749 1.96-37.184 15.141-12.631 19.739-5.437 46.366 14.654 54.004z",
    fill: "url(#SVGID_56_)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPizza);
export default __webpack_public_path__ + "static/media/icon-pizza.a085d9c03ae63742afa9bc6ed0d3ee0a.svg";
export { ForwardRef as ReactComponent };